import { Component, Input, ViewEncapsulation } from '@angular/core';

export class EaBreadcrumb {
  label: string;
  url?: string;

  constructor(label: string, url?: string) {
    this.label = label;
    this.url = url;
  }
}

@Component({
    selector: 'pr-breadcrumb',
    templateUrl: './pr-breadcrumb.component.html',
    styleUrls: ['./pr-breadcrumb.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrBreadcrumbComponent {
  @Input() links: EaBreadcrumb[];

  constructor() {}
}
